import {
  CHANGE_MODAL_COMPONENT,
  CHANGE_MODAL_STATE
} from "constants/type";

export const handleShowModal = (dispatch, component, modal_state) => {
    dispatch({type: CHANGE_MODAL_STATE, payload: modal_state});
    dispatch({type: CHANGE_MODAL_COMPONENT, payload: component});
};
